import 'jquery-validation';

import Inputmask from "inputmask";

export default class InputmaskClass {
    constructor() {
        Inputmask().mask($('input'));
    }
};
